export const unitIdToName = (id) => {
  const box = {
    0: '人',
    1: '儿童',
    2: '天',
    3: '次',
    4: '份',
    5: '辆',
    6: '张',
  }
  return box[id] === undefined ? box[1] : box[id];
}

export const saveSearchCondition = (str = '') => {
  sessionStorage.setItem('products_search_condition', str);
}

export const clearSearchCondition = () => {
  sessionStorage.removeItem('products_search_condition');
}

export const readSearchCondition = (str) => {
  return sessionStorage.getItem('products_search_condition') || '';
}